
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppSelect, AppInput, AppButton } from '@/components';
import { useTranslationList } from '@/modules/translation/model/list';
import { ROUTE_NAME_TRANSLATION } from '@/modules/translation/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_TRANSLATION.INDEX,
    components: { AppTable, AppCard, AppFormRow, AppSelect, AppInput, AppButton },
    setup() {
        const { query, v$, list, total, fetchList, actions, localeSupportedOptions } = useTranslationList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Content', key: 'content' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_TRANSLATION.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: {
                            name: ROUTE_NAME_TRANSLATION.TRANSLATE,
                            params: { id: row.id },
                            query: { locale: query.locale }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return {
            query,
            v$,
            table,
            list,
            total,
            fetchList,
            ROUTE_NAME_TRANSLATION,
            localeSupportedOptions,
            TranslationTypes
        };
    }
});

const TranslationTypes = [
    { label: 'Name', value: 0 },
    { label: 'Value', value: 1 }
];
